import qs from 'qs'

export const queryNewsPage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `news-page?${query}`
}
